// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.ms-mobile-toggle {
  display: none !important;
}

@media (max-width: 768px) {
  .ms-mobile-toggle {
    display: flex !important;
  }
}`, "",{"version":3,"sources":["webpack://./src/main/webapp/app/shared/layout/header/header.scss"],"names":[],"mappings":"AAGA;EACE,wBAAA;AAFF;;AAKA;EACE;IACE,wBAAA;EAFF;AACF","sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
